import { useEffect, useState } from 'react';
import { SiteHeader } from '../components/SiteHeader.tsx';
import { SiteFooter } from '../components/SiteFooter.tsx';
import { Hero } from '../sections/Hero.tsx';
import { OfferBand } from '../sections/OfferBand.tsx';
import { Treatments } from '../sections/Treatments.tsx';
import { About } from '../sections/About.tsx';
import { Studio } from '../sections/Studio.tsx';
import { Visit } from '../sections/Visit.tsx';
import { Faq } from '../sections/Faq.tsx';
import { api, type CatalogueResponse, type StudioResponse } from '../lib/api.ts';
import './home.css';

export function Home() {
  const [catalogue, setCatalogue] = useState<CatalogueResponse | null>(null);
  const [studio, setStudio] = useState<StudioResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  // Empty until /api/studio answers; every section falls back to its own copy,
  // so the page never renders with blank headings.
  const content = studio?.content ?? {};

  useEffect(() => {
    const controller = new AbortController();

    // The menu and the opening hours both come from the API so that an admin
    // price or hours change shows on the homepage without a redeploy.
    Promise.all([
      api.getServices(controller.signal),
      api.getStudio(controller.signal),
    ])
      .then(([catalogueResponse, studioResponse]) => {
        setCatalogue(catalogueResponse);
        setStudio(studioResponse);
      })
      .catch((caught: unknown) => {
        if ((caught as Error)?.name === 'AbortError') return;
        setError((caught as Error).message ?? 'The treatment menu could not be loaded.');
      });

    return () => controller.abort();
  }, []);

  return (
    <>
      <a className="skip-link" href="#treatments">
        Skip to treatments
      </a>
      <SiteHeader variant="home" />
      <main>
        <Hero content={content} />
        <OfferBand offer={catalogue?.siteWideOffer} />
        <Treatments catalogue={catalogue} error={error} />
        <About content={content} />
        <Studio content={content} />
        <Faq studio={studio} />
        <Visit studio={studio} />
      </main>
      <SiteFooter />
    </>
  );
}
